export default __webpack_public_path__ + "static/media/dhe.c52b49df.png";